import * as React from 'react'; 
import { BaseComponent, BaseComponentProps, BaseComponentState } from '../base/BaseComponent';
import { ColapsePanel } from '../core/index';
import { HotelBedCatalogData, HotelBedData, BookingData, HotelBedBookingData } from 'src/shared';
import { getAjaxhelper, momentDuration } from 'src/utils';
import { BookingHotelPanel } from './BookingHotelPanel';
import * as  moment from 'moment';
import { RoomAvailabilityList } from 'src/hotels/RoomAvailabilityList';
import { BookingRightPanel } from './BookingRightPanel';
import { requestToken } from '../utils/request-token';
import { BookingRoomDetailPanel } from './BookingRoomDetailPanel';
import { History } from 'history';
import { BHAM_STORAGE_WISHLIST, BHAM_STORAGE_AFFILIATE, scrollToTop } from '../core/Const';
export interface BookingMainPanelNewProps extends BaseComponentProps {
    reqKey: string;
    roomCheckoutId: number;
    bookNow: number;
    lang: string;
    currencyCode: string;
    history: History;
    firebaseApp: firebase.app.App;
    classright: string;
}

export interface BookingMainPanelNewState extends BaseComponentState {
    bookingData: HotelBedCatalogData.Hotel;
    requesting: boolean;
    oneDolar: boolean;
    bookNow: 'yes' | 'no';
    bookingRequestParameter?: BookingData.HotelBookCheckoutData;
    leadOnly: 'leadOnly' | 'leadPerRoom' | 'allPassanger';
    cuponCode: string;
    cuponError: any;
    totalValue: number;
    totalAsli: number;
    // adaCupon: boolean;
    classCupon: string;
    // discountName: string;
    // totalDisc: number;
    token: string;
    roomDatas: HotelBedData.ChackRateHotelRoomRoom[];
    errorInput: string[];
}

export class BookingMainPanelNew extends BaseComponent<BookingMainPanelNewProps, BookingMainPanelNewState> {
    constructor(props: BookingMainPanelNewProps) {
        super(props);
        this.state = {
            // rates: [],
            roomDatas: [],
            bookingData: {},
            requesting: true,
            oneDolar: false,
            bookNow: props.bookNow === 1 ? "yes" : "no",
            bookingRequestParameter: {
                language: props.lang,
                holder: {
                    name: '',
                    surname: '',
                    email: ''
                },
                rooms: [],
                remark: '',
                arrival: {},
                hotelCode: 0,
                totalAmount: 0,
                currencyCode: props.currencyCode,
                reqKey: props.reqKey,
                exchangeRate: 0,
                discountAmount: 0,
                discountName: '',
                cuponCode: '',
                haveCupon: false
            }, leadOnly: 'leadOnly',
            cuponCode: '',
            cuponError: '', totalValue: 0, totalAsli: 0, classCupon: '', token: '', errorInput: []
        };
    }
    componentWillMount() {
        scrollToTop();
        this.getData();
        this.getToken();
    }
    getToken: () => any = () => {
        requestToken().then(d => {
            // this.setState({ token: d });
            this.setStateHelper(
                st => {
                    st.token = d;
                }
            );
        }).catch(exc => {
            console.log(exc);
        });
    }
    getData() {
        let id = this.props.roomCheckoutId ? this.props.roomCheckoutId : 11678;
        getAjaxhelper().post("/dynamics/hb-api/hotel-booking-data-collection", {
            id: id
        }).then(
            (d: HotelBedCatalogData.Hotel) => {
                let oneDolar: boolean = false;
                let tglSekarang = new Date();
                let tmpTanggal = new Date("2100-12-31");
                let checkOneDolar = true;
                let stateRates: HotelBedData.Rate[] = [];
                let roomsParameters: HotelBedBookingData.BookingRequestRoomParameter[] = [];
                if (d.roomData && d.roomData.rateDetail) {
                    for (let room of Object.keys(d.roomData.rateDetail)) {
                        let rDetail: { jumlah: number, rates: HotelBedData.Rate[], roomFullCode: string, roomName: string } = d.roomData.rateDetail[room];
                        for (let rate of rDetail.rates) {
                            for (let i = 0; i < rate.jumlah!; i++) {
                                stateRates.push(rate);
                                roomsParameters.push({ rate: rate, roomName: rDetail.roomName, boardName: d.roomData.boardName, rateKey: rate.rateKey!, paxes: [{ name: '', surname: '', type: 'AD' }] });
                            }
                            if (rate.cancellationPolicies) {
                                for (let policy of rate.cancellationPolicies) {
                                    let dtFrom = new Date(policy.from!);
                                    let a = moment(dtFrom);
                                    let b = moment(tglSekarang);
                                    let jumlahHari = moment.duration(a.diff(b)).as("day");
                                    if (dtFrom < tmpTanggal) {
                                        tmpTanggal = dtFrom;
                                    }
                                    if (jumlahHari >= 21) {
                                        if (checkOneDolar) {
                                            oneDolar = true;
                                        }
                                    } else {
                                        checkOneDolar = false;
                                        oneDolar = false;
                                    }
                                }
                            }
                        }
                    }
                }
                this.setStateHelper(
                    st => {
                        st.bookingData = d;
                        st.requesting = false;
                        st.oneDolar = oneDolar;
                        st.totalAsli = d.roomData!.net!;
                        st.totalValue = d.roomData!.net!;
                        st.bookingRequestParameter! = {
                            rooms: roomsParameters,
                            hotelCode: d.code!,
                            language: this.props.lang,
                            holder: {
                                name: '',
                                surname: '',
                                email: ''
                            },
                            remark: '',
                            arrival: {},
                            totalAmount: d.roomData!.net!,
                            currencyCode: this.props.currencyCode,
                            reqKey: this.props.reqKey,
                            exchangeRate: 0,
                            discountAmount: 0,
                            discountName: '',
                            cuponCode: '',
                            haveCupon: false
                        };
                    },
                    () => {
                        if (window['fbq']) {
                            window['fbq']('track', 'AddToCart', {
                                content_name: d.name,
                                content_type: 'product',
                                content_ids: [this.props.roomCheckoutId],
                                content: [{
                                    id: this.props.roomCheckoutId,
                                    code: d.code,
                                    roomCheckoutId: this.props.roomCheckoutId, 
                                    roomData: d.roomData 
                                }]
                            });
                        }
                    }
                );
            }
        ).catch(
            exc => {
                console.log(exc);
            }
        );
    }
    render() {
        if (this.state.haveReactError) {
            return this.renderErrorPanel();
        }
        if (this.state.requesting) {
            return this.renderLoadingPanel();
        }

        let detailHotelStyle: any = { };
        let classNameDetail = "col-md-9";
        if (this.props.bookNow === 0) {
            detailHotelStyle = {
                display: 'none'
            };
            classNameDetail = "col-md-12";
        }

        let isiRateCommend = [];
        let adarateCommend = 0;
        let addInformation = <span />;
        let getCmsContent: (x2: any) => any = (x2: any) => {
            return { __html: x2 };
        };
        let jumlahHari = 0;
        if (this.state.bookingData && this.state.bookingData.roomData && this.state.bookingData.roomData.retComment) {
            let rComment = JSON.parse(this.state.bookingData.roomData.retComment);
            let idxRateCommDesc: { [id: string]: HotelBedCatalogData.RateComment } = {};
            for (let com of rComment) {
                if (!(idxRateCommDesc[com.dateStart + '-' + com.dateEnd + '-' + com.description])) {
                    idxRateCommDesc[com.dateStart + '-' + com.dateEnd + '-' + com.description] = {};
                }
                idxRateCommDesc[com.dateStart + '-' + com.dateEnd + '-' + com.description] = com;
            }
            for (let a of Object.keys(idxRateCommDesc)) {
                let rateComment = idxRateCommDesc[a];
                let dateFrom = <span />;
                let dateEnd = <span />;
                let masuk = 0;
                if ((rateComment.dateStart)) {
                    dateFrom = <span>From {rateComment.dateStart} </span>;
                    masuk = 1;
                }
                if ((rateComment.dateEnd)) {
                    dateEnd = <span> Until {rateComment.dateEnd} </span>;
                    masuk = 1;
                }
                if (masuk === 1) {
                    isiRateCommend.push(
                        <p>{dateFrom} {dateEnd}</p>
                    );
                }
                isiRateCommend.push(
                    <p dangerouslySetInnerHTML={getCmsContent(rateComment.description)} />
                );
                adarateCommend = 1;
            }
        }
        let rateComm = <span />;
        if (adarateCommend === 1) {
            rateComm = (
                <p>{isiRateCommend}</p>
            );
            addInformation = (
                <ColapsePanel
                    colapse={false}
                    title='Additional Information'
                    component={rateComm}
                />
            );
        }
        let otherRoom = <span />;
        if (this.state.bookingData.bookingSumary) {
            let stdt = moment(this.state.bookingData.bookingSumary!.checkIn);
            let endt = moment(this.state.bookingData.bookingSumary!.checkOut);
            jumlahHari = momentDuration(endt.diff(stdt)).as('day');
            otherRoom = (
                <RoomAvailabilityList
                    history={this.props.history}
                    classright={''}
                    firebaseApp={this.props.firebaseApp} 
                    lang={this.props.lang}
                    night={jumlahHari + ''}
                    currencyCode={this.props.currencyCode}
                    reqAvailableDetailId={this.state.bookingData.reqAvailableDetailId!}
                    reqKey={this.props.reqKey}
                    sameWindow={true}
                    key={this.state.bookingData.reqAvailableDetailId!}
                />
            );
        }
        let fullPaymentOption: any[] = [];
        let paxisDetail: any[] = [];
        let bookingDetail = (data: HotelBedBookingData.BookingRequestRoomParameter) => {
            //
            console.log(data);
        };
        let lop = 0;
        for (let r of this.state.bookingRequestParameter!.rooms!) {
            lop++;
            paxisDetail.push(
                <BookingRoomDetailPanel leadOnly={this.state.leadOnly} bookingDetail={bookingDetail} RoomParameter={r} roomId={lop} />
            );
        }
        let errorInput: any[] = [];
        for (let e of this.state.errorInput) {
            errorInput.push(
                <div className="alert alert-danger">
                    <button type="button" className="close" data-dismiss="alert" aria-label="Close">
                        <span aria-hidden="true">×</span>
                    </button>
                    {e}
                </div>
            );
        }
        let component = (
            <div> 
                {errorInput}
                <div className='col-md-6'>
                    <div className="form-group">
                        <label>Name </label>
                        <input
                            type="text"
                            required={true}
                            className="form-control"
                            placeholder="Enter your name"
                            onBlur={(event) => {
                                let val: string = event.target.value;
                                this.setStateHelper(st => {
                                    st.bookingRequestParameter!.holder.name = val;
                                    if (st.leadOnly === 'leadOnly') {
                                        for (let bookpar of st.bookingRequestParameter!.rooms) {
                                            for (let p of bookpar.paxes!) {
                                                if (p.type === 'AD') {
                                                    p.name = val;
                                                }
                                            }
                                        }
                                    }

                                });
                            }}
                        />
                    </div>
                </div>
                <div className='col-md-6'>
                    <div className="form-group">
                        <label>Surname </label>
                        <input
                            type="text"
                            className="form-control"
                            required={true}
                            placeholder="Enter your surname"
                            onBlur={(event) => {
                                let val: string = event.target.value;
                                this.setStateHelper(st => {
                                    st.bookingRequestParameter!.holder.surname = val;
                                    if (st.leadOnly === 'leadOnly') {
                                        for (let bookpar of st.bookingRequestParameter!.rooms) {
                                            for (let p of bookpar.paxes!) {
                                                if (p.type === 'AD') {
                                                    p.surname = val;
                                                }
                                            }
                                        }
                                    }

                                });
                            }}
                        />
                    </div>
                </div>
                <div className='col-md-6'>
                    <div className="form-group">
                        <label>Email </label>
                        <input
                            type="email"
                            className="form-control"
                            placeholder="Enter email"
                            onBlur={(event) => {
                                let val: string = event.target.value;
                                this.setStateHelper(st => {
                                    st.bookingRequestParameter!.holder.email = val;
                                });
                            }}
                        />
                    </div>
                </div>
                <div className='col-md-6'>
                    <div className="form-group">
                        <label>Phone </label>
                        <input
                            type="text"
                            className="form-control"
                            required={true}
                            placeholder="Enter your phone number"
                            onBlur={(event) => {
                                let val: string = event.target.value;
                                this.setStateHelper(st => {
                                    st.bookingRequestParameter!.holder.phone = val;
                                });
                            }}
                        />
                    </div>
                </div>   
                <div className='col-md-4'>
                    <div className="form-group">
                        <label>Country </label>
                        <input
                            type="text"
                            className="form-control"
                            required={true}
                            placeholder="Enter your country"
                            onBlur={(event) => {
                                let val: string = event.target.value;
                                this.setStateHelper(st => {
                                    st.bookingRequestParameter!.holder.country = val;
                                });
                            }}
                        />
                    </div>
                </div> 
                
            </div>
        );
        let titleRes = "Reserve Your Room";
        if (this.props.bookNow === 0) {
            titleRes = "Reserve Your Room for $1 Now";
        }
        fullPaymentOption.push(
            <ColapsePanel
                colapse={true}
                title={titleRes}
                component={component}
            />
        );
        if (this.state.leadOnly !== 'leadOnly') {
            for (let px of paxisDetail) {
                fullPaymentOption.push(<div>{px}</div>);
            }
        }

        let compArr = (
            <div>
                <div className='col-md-6'>
                    <div className="form-group">
                        <label>Your Flight </label>
                        <input
                            type="text"
                            className="form-control"
                            placeholder="Enter your flight name and flight number"
                            onBlur={(event) => {
                                let val: string = event.target.value;
                                this.setStateHelper(st => {
                                    st.bookingRequestParameter!.arrival!.flightNumber = val;
                                });
                            }}
                        />
                    </div>
                </div>
                <div className='col-md-6'>
                    <div className="form-group">
                        <label>Your Arrival Time </label>
                        <input
                            type="text"
                            className="form-control"
                            placeholder="Enter your arrive time schadule"
                            onBlur={(event) => {
                                let val: string = event.target.value;
                                this.setStateHelper(st => {
                                    st.bookingRequestParameter!.arrival!.arrivalTime = val;
                                });
                            }}
                        />
                    </div>
                </div>
            </div>
        );

        let AddInfo  = [];

        AddInfo.push(
            <ColapsePanel
                colapse={true}
                title='Your Arrival Detail'
                component={compArr}
            />
        );
        let componentsp = (
            <
                textarea
                className="form-control autosize area-animated"
                onBlur={
                    event => {
                        let val: string = event.target.value ? event.target.value : '';
                        this.setStateHelper(
                            st => {
                                st.bookingRequestParameter!.remark = val;
                            }
                        );
                    }
                }
            />
        );
        AddInfo.push(
            < ColapsePanel
                colapse={true}
                title='Special Request/Comments (max: 2000 characters) '
                component={componentsp}
            />
        );
        fullPaymentOption.push(
            <div className='row' />
        );
        let paymentPlant: any = <span />;
        let isiBooking = (
            <div>
                <span style={{ lineHeight: '34px', display: 'block' }}>
                    Credit Card (Stripe) 100% Secure On Line Payment  </span>  <i style={{ fontSize: 25 }} className='fa fa-credit-card' />    <i style={{ fontSize: 25 }} className='fa fa-cc-stripe' />   <i style={{ fontSize: 25 }} className='fa fa-cc-visa' />   <i style={{ fontSize: 25 }} className='fa fa-cc-mastercard' />   <i style={{ fontSize: 25 }} className='fa fa-cc-discover' />   <i style={{ fontSize: 25 }} className='fa fa-cc-amex' />
                {this.renderCheckoutButton()}
            </div>
        );
        if (this.state.bookNow === 'no') {
            isiBooking = (
                <div>
                    <span style={{ lineHeight: '34px', color: 'green', fontSize: 14, fontWeight: 800  }}>
                    Book This Room For $1 Deposit And Pay Balance 14 Days Before Arrival* - No Credit Card Required Now</span> 
                    <button onClick={this.submitCheckoutData} className="btn btn-primary" style={{float: 'right'}}>Reserve Now Pay Later</button>
                </div>
            );
        }
        let isiPaymentPlant: any = (
            <div className="col-md-12  ">
                <div
                    className="radio clip-radio radio-primary radio-inline"
                    style={detailHotelStyle}
                    onClick={
                        (evt) => {
                            this.setStateHelper(st => {
                                st.bookNow = "no";
                            });
                        }}
                >
                    <input type="radio" id="radio1" name="payment" value="radio1" checked={this.state.bookNow === 'no'} />
                    <label  > $1 Deposit And Pay Later </label>
                </div>
                <div
                    className="radio clip-radio radio-primary radio-inline"
                    style={detailHotelStyle}
                    onClick={
                        (evt) => {
                            this.setStateHelper(st => {
                                st.bookNow = 'yes';
                            });
                        }}
                        
                >
                    <input type="radio" id="radio2" name="payment" value="radio2" checked={this.state.bookNow === 'yes'} />
                    <label  > Full Payment Option </label>
                </div>
                {isiBooking}
            </div>
        );
        paymentPlant = (
            <ColapsePanel
                colapse={true}
                title='Reserve Your Room'
                component={isiPaymentPlant}
            />
        );

        let paymentPlan = [];
        if (this.state.oneDolar) {
            paymentPlan.push(paymentPlant);

        } else {
            paymentPlan.push(
                <div className='col-md-12  checkout-view' style={{ marginBottom: 20, border: '1px solid', borderColor: 'rgba(0, 0, 0, 0.07)', borderRadius: 3, background: '#fff', padding: 15 }} >
                    <span style={{ lineHeight: '34px' }}>
                        Credit Card (Stripe) 100% Secure On Line Payment  </span>  <i style={{ fontSize: 25 }} className='fa fa-credit-card' />    <i style={{ fontSize: 25 }} className='fa fa-cc-stripe' />   <i style={{ fontSize: 25 }} className='fa fa-cc-visa' />   <i style={{ fontSize: 25 }} className='fa fa-cc-mastercard' />   <i style={{ fontSize: 25 }} className='fa fa-cc-discover' />   <i style={{ fontSize: 25 }} className='fa fa-cc-amex' />
                    {this.renderCheckoutButton()}
                </div>
            );
        } 

        return (
            <div className='container' style={{ paddingTop: 140 }}>
                <div className={classNameDetail}>
                    <BookingHotelPanel hotelData={this.state.bookingData} lang={this.props.lang} />
                    <div className='row' />
                    {fullPaymentOption} 
                    <div className='row' />
                    {paymentPlan}
                    <div className='row' />
                    {AddInfo}
                    <div className='row' />
                    {addInformation}
                    <div className='row' />
                    <div className="mobile-only"  style={detailHotelStyle}>
                        <BookingRightPanel oneDolar={this.state.oneDolar} updateCoupon={this.updateCoupon} totalValue={this.state.totalAsli} bookingData={this.state.bookingData} collapse={false} currencyCode={this.props.currencyCode} />
                    </div> 
                    <div className='row' />
                    <ColapsePanel
                        colapse={true}
                        title='Room Upgrade Options'
                        component={otherRoom} 
                    />
                </div>
                <div className='col-md-3 desktop-only' style={detailHotelStyle}>
                    <BookingRightPanel  oneDolar={this.state.oneDolar}  updateCoupon={this.updateCoupon} totalValue={this.state.totalAsli} bookingData={this.state.bookingData} collapse={true} currencyCode={this.props.currencyCode} />
                </div>

            </div>
        );
    }

    renderCheckoutButton() {
        let buttonStyle: any = {};
        let btnPanel: any = (
            <span style={{ float: 'right' }}>
                <button onClick={this.submitCheckoutData} id='btn_submit_checkout' type='submit' className='btn btn-primary' style={buttonStyle}>
                    Checkout
            </button>
            </span>
        );
        return btnPanel;

    }

    submitCheckoutData = () => {
        let checker: { status: boolean, pesan: any[] } = this.mandetoryChecker();
        let affId =  localStorage.getItem (BHAM_STORAGE_AFFILIATE);
        let wishListId = sessionStorage.getItem(BHAM_STORAGE_WISHLIST);
        let bookNow: "FULLPAYMENT" | "ONEDOLARDEPOSIT" = 'FULLPAYMENT';
        if (this.state.bookNow === 'no') {
            bookNow = 'ONEDOLARDEPOSIT';
        }
        if (checker.status) {
            let bookingCheckout: BookingData.BookingCheckOut = {
                arrival: JSON.stringify(this.state.bookingRequestParameter!.arrival),
                checkIn: this.state.bookingData.bookingSumary!.checkIn as any,
                checkOut: this.state.bookingData.bookingSumary!.checkOut as any,
                cuponCode: this.state.bookingRequestParameter!.cuponCode,
                currencyCode: this.state.bookingRequestParameter!.currencyCode,
                discountAmount: this.state.bookingRequestParameter!.discountAmount,
                discountName: this.state.bookingRequestParameter!.discountName,
                haveCupon: this.state.bookingRequestParameter!.haveCupon ? "TRUE" : "FALSE",
                oneDolarDeposit: this.state.bookNow === 'yes' ? "FALSE" : "TRUE",
                holder: JSON.stringify(this.state.bookingRequestParameter!.holder),
                hotelCode: this.state.bookingRequestParameter!.hotelCode,
                language: this.props.lang,
                remark: this.state.bookingRequestParameter!.remark,
                rooms: JSON.stringify(this.state.bookingRequestParameter!.rooms),
                totalAmount: this.state.bookingRequestParameter!.totalAmount,
                passanger: this.state.leadOnly,
                reqKey: this.props.reqKey,
                wishlistCode: wishListId!,
                affiliateCode: affId!,
                bookingType: bookNow
            };
            getAjaxhelper().put(`/dynamics/bham-api/checkout-booking.bham`, { data: bookingCheckout, token: this.state.token }).then(
                d => { 
                    if (this.state.bookNow === 'no') { 
                        getAjaxhelper().post("/dynamics/booking-api/bookingprocess", {checkoutId: d.id, stripeKey: 'oneDolarDeposit', stripeEmail: 'admin@balihotelsandmore.com' }).then(
                            (e: BookingData.BookingCheckOut) => {
                                // this.props.history.push(`/booking-progress?id=${d.id}`);
                                if (window['fbq']) {
                                    window['fbq']('track', 'AddToWishlist', {
                                        content_name: this.state.bookingRequestParameter!.holder.name,
                                        content_category: `OneDolarDeposit`,
                                        content_ids: this.state.bookingRequestParameter!.hotelCode,
                                        contents: this.state.bookingRequestParameter!,
                                        currency: this.props.currencyCode,
                                        value: this.state.totalValue
                                    });
                                }
                                this.props.history.push('/settlement-thankyou');
                            }
                        ).catch(err => { 
                            console.error(err);
                        });  
                    } else {
                        window.location.href  = `/booking-checkout?id=${d.id}`;
                    } 
                }
            ).catch(
                exc => {
                    this.getToken();    
                    console.log(exc);
                }
            );  
        } else {
            this.setStateHelper(
                st => {
                    st.errorInput = checker.pesan;
                }
            );
        }

    }

    mandetoryChecker = () => {
        let status = true;
        let pesan: any[] = [];
        if (!this.state.bookingRequestParameter || !this.state.bookingRequestParameter.holder || !this.state.bookingRequestParameter.holder.name || this.state.bookingRequestParameter.holder.name.length === 0) {
            status = false;
            pesan.push("Passanger Name is Mandatory to Enter");
        }
        if (!this.state.bookingRequestParameter || !this.state.bookingRequestParameter.holder || !this.state.bookingRequestParameter.holder.surname || this.state.bookingRequestParameter.holder.surname.length === 0) {
            status = false;
            pesan.push("Passanger Surname is Mandatory to Enter");
        }
        if (!this.state.bookingRequestParameter || !this.state.bookingRequestParameter.holder || !this.state.bookingRequestParameter.holder.phone || this.state.bookingRequestParameter.holder.phone.length === 0) {
            status = false;
            pesan.push("Passanger Phone is Mandatory to Enter");
        }
        /*
        if (!this.state.bookingRequestParameter || !this.state.bookingRequestParameter.holder || !this.state.bookingRequestParameter.holder.address || this.state.bookingRequestParameter.holder.address.length === 0) {
            status = false;
            pesan.push("Passanger Address is Mandatory to Enter");
        }
        if (!this.state.bookingRequestParameter || !this.state.bookingRequestParameter.holder || !this.state.bookingRequestParameter.holder.postalCode || this.state.bookingRequestParameter.holder.postalCode.length === 0) {
            status = false;
            pesan.push("Passanger Postal/ Zip Code is Mandatory to Enter");
        }
        if (!this.state.bookingRequestParameter || !this.state.bookingRequestParameter.holder || !this.state.bookingRequestParameter.holder.city || this.state.bookingRequestParameter.holder.city.length === 0) {
            status = false;
            pesan.push("Passanger City is Mandetory to Enter");
        }
        */
        if (!this.state.bookingRequestParameter || !this.state.bookingRequestParameter.holder || !this.state.bookingRequestParameter.holder.country || this.state.bookingRequestParameter.holder.country.length === 0) {
            status = false;
            pesan.push("Passanger Country is Mandetory to Enter");
        }
        return {
            status, pesan
        };
        //
    }

    clearPaxis: (st: any, name: string, surname: string, fromIndex: number) => any = (st: any, name: string, surname: string, fromIndex: number) => {

        for (let a of st.bookingRequestParameter!.rooms) {
            let lop = 0;
            for (let b of a.paxes) {
                if (lop >= fromIndex) {
                    b.name = name;
                    b.surname = surname;
                }
                lop++;
            }
        }
    }

    private renderLoadingPanel(): JSX.Element {
        return (
            <div className="col-md-12 bg-white" style={{ minHeight: 500, textAlign: "center", paddingTop: '10%' }}>
                <h4>Please Wait</h4>
                <div className='loader' />
            </div>

        );
    }
    updateCoupon = (adaCupon: boolean, discountName: string, totalDisc: number, cuponCode: string) => {
        this.setStateHelper(
            st => {
                st.bookingRequestParameter!.haveCupon = adaCupon;
                st.bookingRequestParameter!.discountName = discountName;
                st.bookingRequestParameter!.discountAmount = totalDisc;
                st.bookingRequestParameter!.cuponCode = cuponCode;
                st.totalValue = st.totalAsli - totalDisc;
            }
        );
    }
} 
 
    /*
<div className='col-md-12'>
    <div
        className="radio clip-radio radio-primary radio-inline"
        onClick={
            (evt) => {
                this.setStateHelper(st => {
                    st.leadOnly = 'leadOnly';
                    if ((this.state.bookingData) && (this.state.bookingData.roomData)) {
                        this.state.bookingRequestParameter!.rooms!.forEach(rt => {
                            // let paxes: HotelBedBookingData.BookingRequestPaxParameter[] = [];
                            this.clearPaxis(st, this.state.bookingRequestParameter!.holder.name, this.state.bookingRequestParameter!.holder.surname, 0);
                        });
                    }

                });
            }}
    >
        <input type="radio" id="radio1" name="inline" value="radio1" checked={this.state.leadOnly === 'leadOnly'} />
        <label  >  Enter The Name Of Main Passenger </label>
    </div>
    <div
        className="radio clip-radio radio-primary radio-inline"
        onClick={
            (evt) => {
                this.setStateHelper(st => {
                    st.leadOnly = 'leadPerRoom';
                    // this.clearPaxis(st, ' ', ' ', 1);
                    for (let a of st.bookingRequestParameter!.rooms) {
                        let newPax: HotelBedBookingData.BookingRequestPaxParameter[] = [];
                        newPax.push({
                            name: a.paxes![0].name,
                            surname: a.paxes![0].surname,
                            type: 'AD',
                            roomId: 1
                        });
                        a.paxes = newPax;
                    }
                });
            }}
    >
        <input type="radio" id="radio2" name="inline" value="radio2" checked={this.state.leadOnly === 'leadPerRoom'} />
        <label  > Enter Name For Main Passenger Per Room </label>
    </div>
    <div
        className="radio clip-radio radio-primary radio-inline"
        onClick={
            (evt) => {
                this.setStateHelper(st => {
                    st.leadOnly = 'allPassanger';
                    // this.clearPaxis(st, ' ', ' ', 1);

                    for (let a of st.bookingRequestParameter!.rooms) {
                        let lops = 0;
                        let newPax: HotelBedBookingData.BookingRequestPaxParameter[] = [];
                        if (a.rate) {
                            for (let i = 0; i < a.rate!.adults!; i++) {
                                if (lops === 0) {
                                    newPax.push({
                                        name: a.paxes![0].name,
                                        surname: a.paxes![0].surname,
                                        type: 'AD',
                                        roomId: 1
                                    });
                                } else {
                                    newPax.push({
                                        name: '',
                                        surname: '',
                                        type: 'AD',
                                        roomId: 1
                                    });
                                }

                                lops++;
                            }
                            for (let i = 0; i < a.rate!.children!; i++) {
                                newPax.push({
                                    name: '',
                                    surname: '',
                                    type: 'CH',
                                    roomId: 1
                                });
                            }
                        }
                        a.paxes = newPax;
                    }
                });
            }}
    >
        <input type="radio" id="radio3" name="inline" value="radio3" checked={this.state.leadOnly === 'allPassanger'} />
        <label  > Enter The Name For All Passengers </label>
    </div>

</div>
    */
 


// WEBPACK FOOTER //
// ./src/new-booking/BookingMainPanelNew.tsx